export enum RelatorioVendasTipo {
  VALOR = 'VALOR',
  QUANTIDADE = 'QUANTIDADE'
}
